var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_320_34284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9336 16.0945C26.3539 16.4938 25.7305 16.5922 25.0305 16.5594C25.025 19.4414 25.0524 22.2633 25.0141 25.1344C24.9868 26.6656 23.6797 27.9508 22.1485 27.9781C20.6172 28.0055 19.0805 27.9891 17.5438 27.9836C17.0516 27.9836 16.7235 27.6281 16.7235 27.1031C16.718 25.807 16.7235 24.5109 16.718 23.2149C16.718 22.3617 16.718 21.5031 16.718 20.65C16.7125 19.7695 16.1602 19.2063 15.2688 19.1953C14.4321 19.1844 13.5954 19.1844 12.7586 19.1953C11.8891 19.2063 11.3313 19.775 11.3313 20.6445C11.3258 22.7609 11.3258 24.8719 11.3258 26.9883C11.3258 27.6938 11.0305 27.9891 10.3196 27.9891C8.93051 27.9891 7.54145 27.9891 6.15238 27.9891C4.32035 27.9836 3.01879 26.7039 3.00785 24.8664C2.99692 22.0992 3.00238 19.3266 3.00238 16.5594C0.464885 16.8 -1.01168 13.9453 0.803947 12.1024C4.55551 8.35079 8.30707 4.59923 12.0641 0.853134C12.2993 0.60704 12.5727 0.404696 12.8735 0.240634C13.7485 -0.196866 15.1102 -0.0601475 15.9414 0.792978C18.0469 2.95313 20.1961 5.06954 22.3289 7.20235C23.9641 8.84298 25.5883 10.4945 27.2508 12.1133C28.3446 13.1797 28.2407 15.225 26.9336 16.0945Z",
    fill: "#99439D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_34284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.af234feff1d0be7cc138007134c1fd01.svg";
export { ForwardRef as ReactComponent };